export default "__VITE_ASSET__oVXAbt6F__"